
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.258.694C5.433.694.694 5.433.694 11.258s4.739 10.564 10.564 10.564 10.564-4.739 10.564-10.564S17.083.694 11.258.694zm0 3.773a3.784 3.784 0 013.773 3.773 3.784 3.784 0 01-3.773 3.773A3.784 3.784 0 017.485 8.24a3.784 3.784 0 013.773-3.773zM8.24 13.522h6.036a3.78 3.78 0 013.77 3.722 9.02 9.02 0 01-6.788 3.069 9.02 9.02 0 01-6.788-3.069 3.78 3.78 0 013.77-3.722z"}})])
          )
        }
      }
    